import { MainContext, MainContextType } from '@/contexts/MainContext'
import { BaseFilters } from '@/types'
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Select,
  Switch,
  Text,
} from '@chakra-ui/react'
import { useContext } from 'react'

interface OwnerFiltersSimpleProps {
  filters: BaseFilters
  onFiltersChange: (filters: BaseFilters) => void
}

export function OwnerFiltersSimple({
  filters,
  onFiltersChange,
}: OwnerFiltersSimpleProps) {
  const { isAdmin } = useContext(MainContext) as MainContextType
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFiltersChange({
      ...filters,
      search: e.target.value,
      page: 1, // Reset to first page when searching
    })
  }

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFiltersChange({
      ...filters,
      sortBy: e.target.value as 'name' | 'email' | 'created_at',
      page: 1, // Reset to first page when sorting
    })
  }

  const handleShowDeletedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFiltersChange({
      ...filters,
      showDeleted: e.target.checked,
      page: 1, // Reset to first page when toggling
    })
  }

  const handleReset = () => {
    onFiltersChange({
      search: '',
      sortBy: 'name',
      page: 1,
      limit: 12,
      showDeleted: false,
    })
  }

  return (
    <Box p={4} borderWidth="1px" borderRadius="md" bg="gray.50">
      <HStack spacing={3} w="100%" align="center">
        {/* Search Input */}
        <Input
          placeholder="Buscar por nome ou email..."
          value={filters.search}
          onChange={handleSearchChange}
          variant="filled"
          bg="white"
          _hover={{ bg: 'white' }}
          _focus={{ bg: 'white', borderColor: 'blue.500' }}
          className="grow min-w-[200px] w-full"
        />

        {/* Sort Label and Select */}
        <Text fontSize="sm" color="gray.600" fontWeight="medium" flexShrink={0}>
          Ordenar:
        </Text>
        <Select
          value={filters.sortBy}
          onChange={handleSortChange}
          variant="filled"
          bg="white"
          _hover={{ bg: 'white' }}
          _focus={{ bg: 'white', borderColor: 'blue.500' }}
          size="sm"
          minWidth="180px"
          maxWidth="180px"
        >
          <option value="name">Nome</option>
          <option value="email">Email</option>
          <option value="created_at">Data de Criação</option>
        </Select>

        {/* Admin Toggle for Deleted Items */}
        {isAdmin && (
          <FormControl display="flex" alignItems="center" width="fit-content">
            <FormLabel
              htmlFor="show-deleted-owners"
              mb="0"
              fontSize="sm"
              color="gray.600"
              whiteSpace="nowrap"
            >
              Mostrar excluídos:
            </FormLabel>
            <Switch
              id="show-deleted-owners"
              isChecked={filters.showDeleted || false}
              onChange={handleShowDeletedChange}
              colorScheme="red"
              size="sm"
            />
          </FormControl>
        )}

        {/* Reset Button */}
        <Button
          onClick={handleReset}
          colorScheme="gray"
          size="sm"
          flexShrink={0}
        >
          Limpar
        </Button>
      </HStack>
    </Box>
  )
}
